import PropTypes from "prop-types";

import { getBluFilterElt } from "./BluFilterElt";

/*
Constants and helpers
*/

const INPUT_MAX_LENGTH = 255;
const INPUT_PLACEHOLDER = "Type and press enter to filter";
const INPUT_REGEX = /^[0-9a-zA-Z._-]*$/;

/*
Component
*/

const HostFilterElt = getBluFilterElt({
  INPUT_MAX_LENGTH,
  INPUT_PLACEHOLDER,
  INPUT_REGEX_COMPLETE: INPUT_REGEX,
  INPUT_REGEX_PARTIAL: INPUT_REGEX,
});

HostFilterElt.propTypes = {
  filterValue: PropTypes.string,
  fieldName: PropTypes.string,
  setFilter: PropTypes.func,
};

HostFilterElt.defaultProps = {
  filterValue: "",
  fieldName: "",
  setFilter: () => {},
};

export default HostFilterElt;
